import { CurrencyDenomination, MonthYear } from '@common/types';
import VueCqrs from '@cqrs/vue-component-cqrs';
import * as c from '@Quest/Metrics/Domain/commands-core';
import { ValueBalanceType, ValueCommitmentType } from '@Quest/Metrics/types';
import { Component } from 'vue-facing-decorator';

@Component
export default class MetricsCommands extends VueCqrs 
{
	invokeDeleteMetricCommandV1(workspaceId: number, strategyId: string, metricId: string)
	{
		const cmd = new c.DeleteMetricCommandV1(workspaceId, strategyId, metricId);
		this.$command(cmd, metricId);
	}

	invokeCreateRevenueMetricCommandV1(workspaceId: number, strategyId: string, id: string, name: string, description: string | null, denomination: CurrencyDenomination, revenueId: string | null,
		isScheduleDependent: boolean, defaultProjectStartDate: MonthYear | null, startDateBoundary: MonthYear | null, endDateBoundary: MonthYear | null, valueCommitmentType: ValueCommitmentType,
		applyBenefitsConfidenceFactor: boolean)
	{
		const cmd = new c.CreateRevenueMetricCommandV1(workspaceId, strategyId, id, name, description, denomination, revenueId,
			isScheduleDependent, defaultProjectStartDate, startDateBoundary, endDateBoundary, valueCommitmentType, applyBenefitsConfidenceFactor);
		this.$command(cmd, id);
	}

	invokeUpdateRevenueMetricCommandV1(workspaceId: number, strategyId: string, id: string, name: string, description: string | null, denomination: CurrencyDenomination, revenueId: string | null,
		isScheduleDependent: boolean, defaultProjectStartDate: MonthYear | null, startDateBoundary: MonthYear | null, endDateBoundary: MonthYear | null, valueCommitmentType: ValueCommitmentType,
		applyBenefitsConfidenceFactor: boolean)
	{
		const cmd = new c.UpdateRevenueMetricCommandV1(workspaceId, strategyId, id, name, description, denomination, revenueId,
			isScheduleDependent, defaultProjectStartDate, startDateBoundary, endDateBoundary, valueCommitmentType, applyBenefitsConfidenceFactor);
		this.$command(cmd, id);
	}

	invokeCreateTotalCostMetricCommandV1(workspaceId: number, strategyId: string, id: string, name: string, description: string | null, denomination: CurrencyDenomination,
		defaultProjectStartDate: MonthYear | null, startDateBoundary: MonthYear | null, endDateBoundary: MonthYear | null, valueCommitmentType: ValueCommitmentType, applyBenefitsConfidenceFactor: boolean)
	{
		const cmd = new c.CreateTotalCostMetricCommandV1(workspaceId, strategyId, id, name, description, denomination,
			defaultProjectStartDate, startDateBoundary, endDateBoundary, valueCommitmentType, applyBenefitsConfidenceFactor);
		this.$command(cmd, id);
	}

	invokeUpdateTotalCostMetricCommandV1(workspaceId: number, strategyId: string, id: string, name: string, description: string | null, denomination: CurrencyDenomination,
		defaultProjectStartDate: MonthYear | null, startDateBoundary: MonthYear | null, endDateBoundary: MonthYear | null, valueCommitmentType: ValueCommitmentType, applyBenefitsConfidenceFactor: boolean)
	{
		const cmd = new c.UpdateTotalCostMetricCommandV1(workspaceId, strategyId, id, name, description, denomination,
			defaultProjectStartDate, startDateBoundary, endDateBoundary, valueCommitmentType, applyBenefitsConfidenceFactor);
		this.$command(cmd, id);
	}

	invokeCreateResourceMetricCommandV1(workspaceId: number, strategyId: string, id: string, name: string, description: string | null, resourceId: string, valueBalanceType: ValueBalanceType,
		isScheduleDependent: boolean, defaultProjectStartDate: MonthYear | null, startDateBoundary: MonthYear | null, endDateBoundary: MonthYear | null, valueCommitmentType: ValueCommitmentType,
		applyBenefitsConfidenceFactor: boolean)
	{
		const cmd = new c.CreateResourceMetricCommandV1(workspaceId, strategyId, id, name, description, resourceId, valueBalanceType,
			isScheduleDependent, defaultProjectStartDate, startDateBoundary, endDateBoundary, valueCommitmentType, applyBenefitsConfidenceFactor);
		this.$command(cmd, id);
	}

	invokeUpdateResourceMetricCommandV1(workspaceId: number, strategyId: string, id: string, name: string, description: string | null, resourceId: string, valueBalanceType: ValueBalanceType,
		isScheduleDependent: boolean, defaultProjectStartDate: MonthYear | null, startDateBoundary: MonthYear | null, endDateBoundary: MonthYear | null, valueCommitmentType: ValueCommitmentType,
		applyBenefitsConfidenceFactor: boolean)
	{
		const cmd = new c.UpdateResourceMetricCommandV1(workspaceId, strategyId, id, name, description, resourceId, valueBalanceType,
			isScheduleDependent, defaultProjectStartDate, startDateBoundary, endDateBoundary, valueCommitmentType, applyBenefitsConfidenceFactor);
		this.$command(cmd, id);
	}


	invokeCreateCapexMetricCommandV1(workspaceId: number, strategyId: string, id: string, name: string, description: string | null, denomination: CurrencyDenomination, accountId: string | null,
		isDepreciation: boolean, isScheduleDependent: boolean, defaultProjectStartDate: MonthYear | null, startDateBoundary: MonthYear | null, endDateBoundary: MonthYear | null,
		valueCommitmentType: ValueCommitmentType)
	{
		const cmd = new c.CreateCapexMetricCommandV1(workspaceId, strategyId, id, name, description, denomination, accountId, isDepreciation, isScheduleDependent,
			defaultProjectStartDate, startDateBoundary, endDateBoundary, valueCommitmentType);
		this.$command(cmd, id);
	}

	invokeUpdateCapexMetricCommandV1(workspaceId: number, strategyId: string, id: string, name: string, description: string | null, denomination: CurrencyDenomination, accountId: string | null,
		isDepreciation: boolean, isScheduleDependent: boolean, defaultProjectStartDate: MonthYear | null, startDateBoundary: MonthYear | null, endDateBoundary: MonthYear | null,
		valueCommitmentType: ValueCommitmentType)
	{
		const cmd = new c.UpdateCapexMetricCommandV1(workspaceId, strategyId, id, name, description, denomination, accountId,
			isDepreciation, isScheduleDependent, defaultProjectStartDate, startDateBoundary, endDateBoundary, valueCommitmentType);
		this.$command(cmd, id);
	}


	invokeCreateResourceCostMetricCommandV1(workspaceId: number, strategyId: string, id: string, name: string, description: string | null, resourceId: string | null, valueBalanceType: ValueBalanceType,
		denomination: CurrencyDenomination, defaultProjectStartDate: MonthYear | null, startDateBoundary: MonthYear | null, endDateBoundary: MonthYear | null, valueCommitmentType: ValueCommitmentType,
		applyBenefitsConfidenceFactor: boolean)
	{
		const cmd = new c.CreateResourceCostMetricCommandV1(workspaceId, strategyId, id, name, description, resourceId, valueBalanceType, denomination,
			defaultProjectStartDate, startDateBoundary, endDateBoundary, valueCommitmentType, applyBenefitsConfidenceFactor);
		this.$command(cmd, id);
	}

	invokeUpdateResourceCostMetricCommandV1(workspaceId: number, strategyId: string, id: string, name: string, description: string | null, resourceId: string | null, valueBalanceType: ValueBalanceType,
		denomination: CurrencyDenomination, defaultProjectStartDate: MonthYear | null, startDateBoundary: MonthYear | null, endDateBoundary: MonthYear | null, valueCommitmentType: ValueCommitmentType,
		applyBenefitsConfidenceFactor: boolean)
	{
		const cmd = new c.UpdateResourceCostMetricCommandV1(workspaceId, strategyId, id, name, description, resourceId, valueBalanceType, denomination,
			defaultProjectStartDate, startDateBoundary, endDateBoundary, valueCommitmentType, applyBenefitsConfidenceFactor);
		this.$command(cmd, id);
	}

	invokeCreateMarginCogsMetricCommandV1(workspaceId: number, strategyId: string, id: string, name: string, description: string | null, revenueId: string | null, denomination: CurrencyDenomination,
		isScheduleDependent: boolean, defaultProjectStartDate: MonthYear | null, startDateBoundary: MonthYear | null, endDateBoundary: MonthYear | null, valueCommitmentType: ValueCommitmentType,
		applyBenefitsConfidenceFactor: boolean)
	{
		const cmd = new c.CreateMarginCogsMetricCommandV1(workspaceId, strategyId, id, name, description, revenueId, denomination,
			isScheduleDependent, defaultProjectStartDate, startDateBoundary, endDateBoundary, valueCommitmentType, applyBenefitsConfidenceFactor);
		this.$command(cmd, id);
	}

	invokeUpdateMarginCogsMetricCommandV1(workspaceId: number, strategyId: string, id: string, name: string, description: string | null, revenueId: string | null, denomination: CurrencyDenomination,
		isScheduleDependent: boolean, defaultProjectStartDate: MonthYear | null, startDateBoundary: MonthYear | null, endDateBoundary: MonthYear | null, valueCommitmentType: ValueCommitmentType,
		applyBenefitsConfidenceFactor: boolean)
	{
		const cmd = new c.UpdateMarginCogsMetricCommandV1(workspaceId, strategyId, id, name, description, revenueId, denomination,
			isScheduleDependent, defaultProjectStartDate, startDateBoundary, endDateBoundary, valueCommitmentType, applyBenefitsConfidenceFactor);
		this.$command(cmd, id);
	}

	invokeCreateExpenseMetricCommandV1(workspaceId: number, strategyId: string, id: string, name: string, description: string | null, expenseAccountId: string | null, valueBalanceType: ValueBalanceType,
		denomination: CurrencyDenomination, isScheduleDependent: boolean, defaultProjectStartDate: MonthYear | null, startDateBoundary: MonthYear | null, endDateBoundary: MonthYear | null,
		valueCommitmentType: ValueCommitmentType, applyBenefitsConfidenceFactor: boolean)
	{
		const cmd = new c.CreateExpenseMetricCommandV1(workspaceId, strategyId, id, name, description, expenseAccountId, valueBalanceType, denomination,
			isScheduleDependent, defaultProjectStartDate, startDateBoundary, endDateBoundary, valueCommitmentType, applyBenefitsConfidenceFactor);
		this.$command(cmd, id);
	}

	invokeUpdateExpenseMetricCommandV1(workspaceId: number, strategyId: string, id: string, name: string, description: string | null, expenseAccountId: string | null, valueBalanceType: ValueBalanceType,
		denomination: CurrencyDenomination, isScheduleDependent: boolean, defaultProjectStartDate: MonthYear | null, startDateBoundary: MonthYear | null, endDateBoundary: MonthYear | null,
		valueCommitmentType: ValueCommitmentType, applyBenefitsConfidenceFactor: boolean)
	{
		const cmd = new c.UpdateExpenseMetricCommandV1(workspaceId, strategyId, id, name, description, expenseAccountId, valueBalanceType, denomination,
			isScheduleDependent, defaultProjectStartDate, startDateBoundary, endDateBoundary, valueCommitmentType, applyBenefitsConfidenceFactor);
		this.$command(cmd, id);
	}



	invokeCreateCostSubtotalMetricCommandV1(workspaceId: number, strategyId: string, id: string, name: string, description: string | null, subtotalId: string, valueBalanceType: ValueBalanceType,
		denomination: CurrencyDenomination, defaultProjectStartDate: MonthYear | null, startDateBoundary: MonthYear | null, endDateBoundary: MonthYear | null, valueCommitmentType: ValueCommitmentType,
		applyBenefitsConfidenceFactor: boolean)
	{
		const cmd = new c.CreateCostSubtotalMetricCommandV1(workspaceId, strategyId, id, name, description, subtotalId, valueBalanceType, denomination,
			defaultProjectStartDate, startDateBoundary, endDateBoundary, valueCommitmentType, applyBenefitsConfidenceFactor);
		this.$command(cmd, id);
	}

	invokeUpdateCostSubtotalMetricCommandV1(workspaceId: number, strategyId: string, id: string, name: string, description: string | null, subtotalId: string, valueBalanceType: ValueBalanceType,
		denomination: CurrencyDenomination, defaultProjectStartDate: MonthYear | null, startDateBoundary: MonthYear | null, endDateBoundary: MonthYear | null, valueCommitmentType: ValueCommitmentType,
		applyBenefitsConfidenceFactor: boolean)
	{
		const cmd = new c.UpdateCostSubtotalMetricCommandV1(workspaceId, strategyId, id, name, description, subtotalId, valueBalanceType, denomination,
			defaultProjectStartDate, startDateBoundary, endDateBoundary, valueCommitmentType, applyBenefitsConfidenceFactor);
		this.$command(cmd, id);
	}
}